import { PLAY_PAUSE_ICON_COLOR } from "~/utils/constant";

function CircularAudioProgress({ offset }: { offset: number }) {
  return (
    <svg
      className="absolute z-0 inset-0"
      style={{ width: "100%", height: "100%" }}
      viewBox="0 0 36 36"
    >
      <circle
        cx="18"
        cy="18"
        r="16"
        fill="none"
        stroke={PLAY_PAUSE_ICON_COLOR}
        strokeWidth="2"
        opacity="0.2"
      />
      <circle
        cx="18"
        cy="18"
        r="16"
        fill="none"
        stroke={PLAY_PAUSE_ICON_COLOR}
        strokeWidth="2"
        strokeDasharray="100"
        strokeDashoffset={offset}
        strokeLinecap="round"
        transform="rotate(180 18 18)"
      />
    </svg>
  );
}

export default CircularAudioProgress;
